import { ValueOf } from './util';

/** 精算サイクルのenum */
export const EClearingCycle = {
  DAILY: '日次',
  TWICE_MONTHLY: '月2回(15日と月末)',
  MONTHLY: '月1回(月末)',
  NONE: '無',
} as const;

export type ClearingCycleKey = keyof typeof EClearingCycle;
export type ClearingCycleValue = ValueOf<typeof EClearingCycle>;

export const clearingCycleKeys = Object.keys(EClearingCycle) as (ClearingCycleKey[]);

/** v-select用items */
export const clearingCycleItems = clearingCycleKeys
  .map((key) => ({
    title: EClearingCycle[key],
    value: key,
  }));
